/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MultipleReturnGetAlertCallsDto } from '../../models/multiple-return-get-alert-calls-dto';

export interface ApiAlertcallsGet$Params {
    /**
     * Query helper for filtering and sorting
     */
    query?: string;

    /**
     * Include corpo details in the response
     */
    populateCorpo?: boolean;

    /**
     * Include answers (partecipanti) in the response
     */
    populateAnswers?: boolean;

    /**
     * Include user details of answers (partecipanti)
     */
    populateAnswersUser?: boolean;
}

export function apiAlertcallsGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiAlertcallsGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<MultipleReturnGetAlertCallsDto>> {
    const rb = new RequestBuilder(rootUrl, apiAlertcallsGet.PATH, 'get');
    if (params) {
        rb.query('query', params.query, {});
        rb.query('populateCorpo', params.populateCorpo, {});
        rb.query('populateAnswers', params.populateAnswers, {});
        rb.query('populateAnswersUser', params.populateAnswersUser, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<MultipleReturnGetAlertCallsDto>;
        }),
    );
}

apiAlertcallsGet.PATH = '/api/alertcalls';
